// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Skeleton_wrapper__0cm5G","skelton":"Skeleton_skelton__1G_HV"};